export default {
    'Placeholder': 'Marcador de posición',
}